// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"72a0d9e5","114":"f308d058","230":"3986bd8f","337":"90709b9e","379":"dfc57ffa","531":"5ee1c264","545":"de8f01ee","746":"139918a9","971":"c9837e30"}[chunkId] + ".chunk.js";
};